import {reisy} from 'reisy';
import './grid.js';

export const styles = reisy`
/******************** Settings ********************/
@namespace Settings;

Branding: true;
YeOldeKosk: false;
JackInTheBox: false;
ShowTime: false;
ShowItemCounts: false;
showLike: false;
KoskMaxWidth: 1920px;
NavBleed: false;
FooterBleed: false;
JackInTheBoxScrollCorrection: 0;
ForceIndexPublishableTitle: false;


/******************** Colors ********************/
@namespace Colors;
Primary: #000;
Secondary: #000;
Accent: #000;
TextDark: #000;
TextLight: #FFF;
TextSubtle: #828282;

/******************** Media Queries ********************/
@namespace Media;

smallest: @media only all and (max-width: 480px);
smaller: @media only all and (max-width: 639px);
small: @media only all and (min-width: 640px);
small2: @media screen and (min-width: 640px);
medium: @media only all and (min-width: 900px);
large: @media only all and (min-width: 1200px);
larger: @media only all and (min-width: 1450px);
largest: @media only all and (min-width: 1800px);

ltSmall: @media only all and (max-width: 639px);
ltMedium: @media only all and (max-width: 899px);
ltLarge: @media only all and (max-width: 1199px);
ltLarger: @media only all and (max-width: 1449px);
ltLargest: @media only all and (max-width: 1799px);

short: @media only all and (max-height: 400px);

portrait: @media screen and (orientation: portrait);
portraitSmall: @media screen and (orientation: portrait) and (max-width: 500px);
landscapeSmall: @media screen and (orientation: landscape) and (max-height: 600px);
landscapeSmallest: @media screen and (orientation: landscape) and (max-height: 400px);


/******************** Some Constants ********************/
@namespace Consts;

Transition: 200ms;


/******************** Browser Environment ********************/
@namespace Environment;

ScrollbarSize: 0;


/******************** Helpers / Mixins ********************/
@namespace Helpers;

AbsFull {
	display: block;
	position: absolute;
	top: 0; right: 0; bottom: 0; left: 0;
}

Fullscreen {
	position: relative;
}
Contain {
	/* Usually, the top/right/... props of fixed positioned elements are relative
	 * to the viewport. But with a bogus null-transform, they are suddenly
	 * relative to the parent element, which is what we want in this case, since
	 * the navigation elements and the prev/next things and fixed page elements
	 * should be relative to our container element. */


	/* Need to disable this if we want to make nav fixed (sticky) */
	/*transform: scale(1);*/

}

Hyphens {
	overflow-wrap: break-word;
	word-wrap: break-word;
	hyphens: auto;
}

Ellipsis {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 1.33;
}

FontSize {
	font-size: 16px;
	$Media.smaller {
		font-size: 14px;
	}
	$Media.larger {
		font-size: 18px;
	}
	$Media.largest {
		font-size: 20px;
	}
}

ScrollbarRight {
	right: $(Environment.ScrollbarSize)px;
}
ScrollbarBottom {
	bottom: $(Environment.ScrollbarSize)px;
}

Clip {
	clip: rect(0 auto auto 0);
	clip-path: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='0' height='0'%3E%3Cdefs%3E%3CclipPath id='clipPolygon' clipPathUnits='objectBoundingBox'%3E%3Crect width='1' height='1' /%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E#clipPolygon");
	clip-path: inset(0 0 0 0);
	overflow: hidden;
}

/***** Pagestrip Normalize ****/
@namespace ;
p {
	margin: 0;
	padding: 0;
	line-height: inherit;
	font-size: inherit;
}

li {
	padding: 0;
	margin: 0;
}

	li::before {
		content: '';
		margin: 0;
		padding: 0;
		display: inline;
	}

h1,
h2,
h3,
h4,
h5,
.kent-page h1:nth-child(n),
.kent-page h2:nth-child(n),
.kent-page h3:nth-child(n),
.kent-page h4:nth-child(n),
.kent-page h5:nth-child(n) {
	margin: 0;
	padding: 0;
	line-height: inherit;
}

.kent-page h1:nth-child(n),
.kent-page h2:nth-child(n),
.kent-page h3:nth-child(n),
.kent-page h4:nth-child(n),
.kent-page h5:nth-child(n) {
	font-size: inherit;
	font-family: inherit;
}

p,
h1,
h2,
h3,
h4,
h5 {
	color: inherit;
}


.kent-page p {
	margin: 0;
	color: inherit;
}
.kent-page h1,
.kent-page h2,
.kent-page h3,
.kent-page h4,
.kent-page h5,
.kent-page h6 {
	margin: 0;
	font-weight: inherit;
	font-size: inherit;
	color: inherit;
	letter-spacing: inherit;
	text-transform: inherit;
	text-align: inherit;
}
.kent-page > div,
.editorPage > div {
	word-wrap: normal !important;
}
.kent-page a {
	color: inherit;
	text-decoration: none;
}
.kent-page iframe {
	-webkit-touch-callout: none;
	-webkit-tap-highlight-color: transparent;
	border: 0;
	overflow: hidden;
}
.kent-page b {
	font-weight: bold;
}
.kent-page i {
	font-style: italic;
}
.kent-page u {
	text-decoration: underline;
}
.kent-page s {
	text-decoration: line-through;
}
.kent-page .extLink {
	cursor: pointer;
}
.kent-page .initial *:first-child:first-letter {
	float: left;
}
.kent-page .initial *:first-child {
	display: block;
}
`;



// WEBPACK FOOTER //
// ./lib/styling/globals.js